import React, { Suspense, useMemo } from 'react';
import { FlagType } from '../../../../../../@types/product.enum';
import { useFlags } from '../../providers/FlagsProvider';
import { InfoIcon } from '../../../../../styled/Icon';
import Distance from '../../../../../styled/Distance';
import Box from '../../../../../styled/Box';
import { Columns } from '../../../../../styled/Columns/wrappers';
import { Column } from '../../../../../styled/Columns/wrappers';
import AlpInformationPanel from '../../ALPInformation';
import useToggle from '../../../../../hooks/useToggle';
import LinkButton from '../../../../../styled/LinkButton';

const ALPInformationBox = () => {
  const ALPCommunicationFlag = useFlags(FlagType.featured);

  const showWindow = useMemo(() => ALPCommunicationFlag, [ALPCommunicationFlag]);
  const [showPanel, toggleShowPanel] = useToggle(false);

  if (!showWindow) {
    return null;
  }

  return (
    <>
      <Distance size="3" />
      <Box background="member" overhang="mobile" rounded>
        <Columns className="space-2">
          <Column>
            <InfoIcon className="xlarge" />
          </Column>
          <Column>
            <span>
              Produkter märkta med Alltid lågt pris kan inte kombineras med erbjudande/värdecheck
            </span>
            <Distance size="half" />
            <LinkButton weight="regular" onClick={toggleShowPanel}>
              Läs mer
            </LinkButton>
          </Column>
        </Columns>
      </Box>
      {showPanel && (
        <Suspense fallback={null}>
          <AlpInformationPanel onClose={toggleShowPanel} />
        </Suspense>
      )}
    </>
  );
};
export default ALPInformationBox;
